import { useEffect, useRef, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';

const isOverflowing = (element: HTMLElement | null): boolean => {
  if (!element) return false;
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

export const useTruncatedText = ({ itemsCount }: { itemsCount: number }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { ref, width } = useResizeDetector<HTMLDivElement>();
  const [visibleCount, setVisibleCount] = useState(itemsCount);

  useEffect(() => {
    if (!containerRef.current || !width) return;

    [...new Array(itemsCount)].forEach((_, i) => {
      const nameElement = containerRef.current?.children[i] as HTMLElement;
      if (nameElement) nameElement.style.display = 'inline';
    });

    if (!isOverflowing(containerRef.current)) {
      setVisibleCount(itemsCount);
      return;
    }

    let lastVisibleIndex = itemsCount - 1;

    for (let i = itemsCount - 1; i > 0; i--) {
      const nameElement = containerRef.current?.children[i] as HTMLElement;
      if (nameElement) nameElement.style.display = 'none';

      if (!isOverflowing(containerRef.current) || i === 1) {
        lastVisibleIndex = i - 1;
        break;
      }
    }

    setVisibleCount(lastVisibleIndex + 1);
  }, [itemsCount, width]);

  return { visibleCount, hiddenCount: itemsCount - visibleCount, ref, containerRef };
};
